import React from 'react'
import '../../pages/portfolio/portfolio.css'

const WorkCard = ({ workItem }) => {

  const {id, title, github, demo, pImg} = workItem

  return (
    <article key={id} className='portfolioItem'>
      <div className="imgBox"><img className="portfolioItemImg" src={pImg} alt="RecentWork" /></div>
      <h3 className='portfolioItemTitle'>{title}</h3>
      <div className="portfolioItemBtn">
        {
          !github ?
            <a style={{ width: "100%" }} className="link button" href={demo} rel="noreferrer" target="_blank">Demo</a> :
            <>
              <a className="link button" href={github} rel="noreferrer" target="_blank">Code</a>
              <a className="link button" href={demo} rel="noreferrer" target="_blank">Demo</a>
            </>
        }
      </div>
    </article>
  )
}

export default WorkCard